import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Avatar from "@mui/material/Avatar";
const ProfilePhoto = ({
  classes,
  profile: {
    picture,
    firstName
  },
  profilePicturePlaceholder,
  pictureStyle
}) => {
  let component;
  if (picture) {
    component = /*#__PURE__*/React.createElement(Avatar, {
      className: `${classes.photo} ${pictureStyle ? pictureStyle : ""}`,
      alt: firstName ? firstName : "",
      src: `data:image/png;base64, ${picture}`,
      id: "profileSummaryPicture"
    });
  } else {
    //placeholder image for users without profile photos
    component = /*#__PURE__*/React.createElement("img", {
      className: `${classes.photo} ${pictureStyle ? pictureStyle : ""}`,
      alt: firstName ? firstName : "",
      src: profilePicturePlaceholder ? profilePicturePlaceholder : "",
      id: "profileSummaryPicture"
    });
  }
  return component;
};
const styles = () => ({
  photo: {
    width: 100,
    height: 100
  }
});
export default withStyles(styles)(ProfilePhoto);
ProfilePhoto.propTypes = {
  classes: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  profilePicturePlaceholder: PropTypes.string,
  pictureStyle: PropTypes.string
};